<template>
<div>
    <div style="background: #ffffff;position:relative;">
        <div class="search-condition-con" :class="'show'">
            <div class="search-condition" >
                <span class="label">代理商</span>
                <div class="input-condition" >
                    <el-autocomplete v-model="condition.factor" :fetch-suggestions="querySearchFactor"  @select="handleSelectFactor" placeholder="请输入代理商名称" valueKey="name" ></el-autocomplete>
                </div>
            </div>
            <div class="search-condition" style="max-width: 300px">
                <span class="label">站点</span>
                <div class="input-condition">
                    <el-autocomplete v-model="condition.site" :fetch-suggestions="querySearchSite" @select="handleSelectSite" placeholder="请输入代理商名称"  valueKey="name"></el-autocomplete>
                </div>
            </div>
            <div class="search-condition" style="min-width: 400px">
                <span class="label">400号码</span>
                <div class="input-condition">
                    <el-autocomplete v-model="condition.tellnumber" :fetch-suggestions="querySearchHotline"  @select="handleSelectHotLine" placeholder="请输入400号码"  valueKey="hotline_number"></el-autocomplete>
                </div>
                <div class="input-condition">
                    <el-autocomplete v-model="condition.telephones" :fetch-suggestions="querySearchTelephone" @select="handleSelectTelephone" placeholder="请输入400分机号"  valueKey="telephone_number"></el-autocomplete>
                </div>
            </div>
            <div class="search-condition search-condition-time">
                <span class="label">时间段</span>
                <div>
                    <a class="quckily" @click="checkDate('month')" :class="condition.timeStamp === 'month' && 'active'">最近30天</a>
                    <a class="quckily" @click="checkDate('doubleMonth')" :class="condition.timeStamp === 'doubleMonth' && 'active'">最近60天</a>
                </div>
                <div class="input-condition" style="min-width: 300px;">
                    <el-date-picker
                            v-model="condition.time"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="请选择开始日期"
                            end-placeholder="请选择结束日期"
                            align="right"
                            @change="condition.timeStamp = ''"
                            value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm"
                    >
                    </el-date-picker>
                </div>
            </div>
        </div>
        <div class="btn-condition">
            <el-button @click="handleSearch" type="primary">查 询</el-button>
            <Permission allowed="business.telephone.unfreeze-ids" isRow="1" style="margin:0 10px;">
                <el-button @click="batchUnFrozen" type="primary">批量解冻</el-button>
            </Permission>
            <el-button @click="resetSearch" >清空条件</el-button>
        </div>
    </div>

    <div>

        <el-table
                :data="list"
                :highlight-current-row="true"
                stripe
                tooltip-effect="dark"
                ref="multipleTable"
                v-loading="isLoading"
                header-cell-class-name="table-back"
                @selection-change="selectItem"
        >
            <!-- 表头：label对应展示的名称 prop对应返回数据列表中绑定的字段名 sortable:标识当前列是否允许排序 -->
            <el-table-column type="selection" width="55" v-if="isShowCheckBox"></el-table-column>
            <el-table-column width="120" label="400号码" prop="hotline_number"></el-table-column>
            <el-table-column width="90" label="分机号" prop="telephone_number"></el-table-column>
            <el-table-column  width="120"  label="代理商" prop="factor" ></el-table-column>
            <el-table-column  label="站点" prop="service_type"></el-table-column>
            <el-table-column  width="120" label="分机号状态" prop="tstatus">
                <template    slot-scope="scope">
                    {{scope.row.tstatus}}<br/>
                    <span style="color: red">剩余{{scope.row.days}}天解冻</span>
                </template>
            </el-table-column>
            <el-table-column  width="120" label="冻结时间" prop="updated_at"></el-table-column>

            <!-- 对于不需要绑定的列则不需要绑定props,如果自定义表头的话也可以不需要绑定label  -->
            <el-table-column width="180" >
                <!-- 绑定插槽slot="header"用来实现自定义表头,slot-scope="scope"返回数据： score:{row: '', $index: number} -->
                <template slot="header"   slot-scope="scope">
                    <span style="color: #409EFF">操作</span>
                </template>
                <!-- 默认插槽绑定列表内容插槽 scope: {$index: 当前下标, row: 当前数据对象} -->
                <template slot-scope="scope">
                    <el-button   size="mini" @click="handleStart(scope.$index, scope.row)" v-permission="'business.telephone.unfreeze'" >解冻</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--  total：一共有多少条数据 page-size一个页面显示多少条数据 @current-change 当点击分页数触发-->
        <template v-if="list.length > 0">
            <!-- :total="list.length" -->
            <el-pagination background layout="total,prev, pager, next" :total="pages.total" :page-size="pages.size" @current-change="currentChange"></el-pagination>
        </template>
    </div>
</div>
</template>
<style>
    .search-condition-con .search-condition{
        width: 30%;
    }
</style>
<script>
    import {
        getHotlinesForBind,
        editCunstomerHotlinesStatus,
        getHotlinesall,
        getCunstomerTelephones, getTelephones
    } from "../../../../service/hotline";
    import {CunstomerHotlinesrescission} from "../../../../service/hotline";
    import {getFactorsList} from "../../../../service/user";
    import {getSite} from "../../../../service/site";
    import {
        editTelephoneStatus,
        editTelephoneUnFrozen, editTelephoneUnFrozenIds,
        getTelephoneForBind,
        getTelephoneNoraml
    } from "../../../../service/telephone";
    import { parseTime } from '@/utils/index'

    export default {
        name: 'frozen',
        data () {
            return {
                page:1,
                statusMap:{
                    0:'冻结',
                    1:'解冻',
                },
                sel:[],
                pages:{
                    total:'',
                    size:''
                },
                dateMap:{
                  "month":-30,
                  "doubleMonth":-60,
                },
                condition: {
                    factorID:'',
                    siteID:'',
                    telephoneID:"",
                    hotlineID:"",
                    factor: '',
                    site: '',
                    type: '',
                    status:'',
                    timeStamp:"",
                    tellnumber:'',
                    time:"",
                    telephones:"",
                    balanceStatus:''
                },
                isShowCheckBox:true,
                isLoading: false, // 是否显示loading加载
                list: []
            }
        },
        mounted() {
            this.initData()
        },
        methods: {
            Thistime(){//当前日期
                var date = new Date();
                var year = date.getFullYear();
                var month = date.getMonth()+1;
                var day = date.getDate();
                var time = year+"-"+month+"-"+day;
                return time;
            },
            DateDiff(starDay, endDay) {  //sDate1和sDate2是yyyy-MM-dd格式
                var arr = [];
                var dates = [];
                // 设置两个日期UTC时间
                var db = new Date(starDay);
                var de = new Date(endDay);
                // 获取两个日期GTM时间
                var s = db.getTime() - 24 * 60 * 60 * 1000;
                var d = de.getTime() - 24 * 60 * 60 * 1000;
            
                // 获取到两个日期之间的每一天的毫秒数
                for (var i = s; i <= d;) {
                    i = i + 24 * 60 * 60 * 1000;
                    arr.push(parseInt(i))
                }
                
                // 获取每一天的时间  YY-MM-DD
                for( var j in arr ){
                    var time = new Date(arr[j]);
                    var year = time.getFullYear(time);
                    var mouth = (time.getMonth() + 1)>=10?(time.getMonth() + 1):('0'+(time.getMonth() + 1));
                    var day = time.getDate()>=10?time.getDate():('0'+time.getDate());
                    var YYMMDD = year + '-' + mouth + '-' + day;
                    dates.push(YYMMDD)
                }
                
                return dates.length//返回相差天数
            },
            getBeforeDate(n){
                var date1 = new Date(), time1=date1.getFullYear()+"-"+(date1.getMonth()+1)+"-"+date1.getDate();//time1表示当前时间
                var date2 = new Date(date1);
                date2.setDate(date1.getDate()+n);
                var time2 = date2.getFullYear()+"-"+(date2.getMonth()+1)+"-"+date2.getDate();
                return [time2,time1];
            },
            checkDate (value) {
                this.condition = Object.assign({}, this.condition, {
                    timeStamp: value,
                    time: this.getBeforeDate(this.dateMap[value])

                })
            },
            changeStatus() {

            },
            //用于代理商自动补全的查询
            async querySearchFactor (queryString, callback) {
                this.condition.siteID = '';
                let result = [];
                await getFactorsList({name:queryString}).then((data) => {
                    result = data.data
                });
                callback(result)
            },
            // 选择代理商id回调
            handleSelectFactor (item) {
                this.condition.factorID = item.id
            },
            //用于站点自动补全的查询
            async querySearchSite(queryString, callback) {
                this.condition.siteID = '';
                let result = {};
                let query = {name:queryString,'factor_id': this.condition.factorID };
                await getSite(query).then((data) => {
                    result = data.data
                });
                callback(result)
            },
            // 选择站点id回调
            handleSelectSite (item) {
                this.condition.siteID = item.id
            },
            //用于站点自动补全的查询
            async querySearchHotline(queryString, callback) {
                this.condition.hotlineID= "";
                let result = [];
                let query = {};
                query['hotline_number'] = queryString;
                await getHotlinesall(query).then((data) =>               {
                    result = data
                });
                callback(result)
            },
            // 选择400号id
            handleSelectHotLine (item) {
                this.condition.hotlineID = item.id
            },
            //用于站点自动补全的查询
            async querySearchTelephone(queryString, callback) {
                this.condition.telephoneID= "";
                if(!this.condition.hotlineID) {
                    this.$message({
                        message:"请选择400号",
                        type: 'error'
                    });
                    return ;
                }
                let result = [];
                let query = {};
                let id = this.condition.hotlineID;
                query['hotline_id'] =this.condition.hotlineID;
                query['telephone_number'] = queryString;
                await getTelephones(id,query).then((data) => {result = data});
                callback(result)
            },
            // 选择400号id
            handleSelectTelephone (item) {
                this.condition.telephoneID = item.id
            },
            //清空
            resetSearch() {
                this.condition = {
                    factorID:'',
                    siteID:'',
                    telephoneID:"",
                    hotlineID:"",
                    factor: '',
                    site: '',
                    type: '',
                    status:'',
                    timeStamp:"",
                    tellnumber:'',
                    time:"",
                    telephones:"",
                    balanceStatus:''
                };
                this.refreshPage();
            },
            //分页设置回调
            currentChange(page) {
                this.page = page;
                this.refreshPage();
            },
            selectItem (val) {
                this.sels = val // 返回的是选中的列的数组集合
            },
            batchUnFrozen() {
                this.$confirm('解冻后，该分机号可重新绑定，请注意短时间复用可能会引起串号问题，是否确认解冻？', '提示',           {
                    confirmButtonText: '确定',
                    type: 'warning'
                }).then(() => {
                    let ids = [];
                    if (!this.sels) {
                        this.$message({
                            type: 'error',
                            message: '请先选择需要解冻的分机号'
                        });
                        return ;
                    }
                    this.sels.forEach(function(val){
                        ids.push(val.id);
                    });
                    if (ids.length<1) {
                        this.$message({
                            type: 'error',
                            message: '请先选择需要解冻的分机号'
                        });
                        return ;
                    }
                    ids= ids.join(',');
                    let query = {'ids':ids};
                    editTelephoneUnFrozenIds(query)                       .then(data=>{
                        this.refreshPage()
                    })
                }).catch(() => {

                });
            },
            //搜索
            handleSearch() {
                this.refreshPage();
            },
            //解冻分机号
            handleStart(i,row) {
                this.$confirm('解冻后，该分机号可重新绑定，请注意短时间复用可能会引起串号问题，是否确认解冻？', '提示', {
                    confirmButtonText: '确定',
                    type: 'warning'
                }).then(() => {
                    let query = {};
                    query['status'] = 0;
                    this.isLoading = true;
                    editTelephoneUnFrozen(row.id,query).then(data=>{
                        this.refreshPage()
                    });
                    this.isLoading = false
                }).catch(() => {

                });


            },
            //刷新列表
            refreshPage() {
                let query = {};
                let form =  this.condition;
                query['factor_id'] = form.factorID;
                query['site_id'] = form.siteID;
                query['type'] = form.type;
                query['status'] = form.status;
                query['hotline_id'] = form.hotlineID;
                query['telephone_id'] = form.telephoneID;
                query['balance_status'] = form.balanceStatus;
                query['updated_start_at'] = form.time[0];
                query['updated_end_at'] = form.time[1];

                query['page'] = this.page;
                // this.$message({
                //     type: '',
                //     message: err.message || '删除失败'
                // })
                this.isLoading = true;
                //query['factor_id'] = user.factor_id
                getTelephoneForBind(query).then((data) => {
                    let listData = data;
                    listData.data.forEach((item,i,list)=>{
                        if(!this.statusMap[item.status]) {
                            listData.data[i].tstatus = '冻结'
                        } else {
                            listData.data[i].tstatus =this.statusMap[item.status]
                        }
                        listData.data[i].days = this.DateDiff(this.Thistime(), parseTime(item.unfreeze_time, '{y}-{m}-{d} {h}:{i}'))
                        //listData.data[i].type = this.typeMap[item.type]
                    });
                    this.list = listData.data;
                    this.pages.size = data.pre_page;
                    this.pages.total = data.total
                });
                // 数据请求完毕取消当前页面的loading
                this.isLoading = false
            },
            /** 初始化数据请求 */
            async initData () {
                // 初始化之前设置当前页面的loading状态
                this.isLoading = true;
                // 模拟fetch请求数据....
                let query = {};
                this.refreshPage();
                // 数据请求完毕取消当前页面的loading
                this.isLoading = false
            }
        }
    }
</script>